import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { CREATE_JOB_TITLE } from "../job-title.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateJobTitleInput } from "../../../__generated__/globalTypes";
import {
  CreateJobTitleMutation,
  CreateJobTitleMutationVariables,
} from "../../../__generated__/CreateJobTitleMutation";

interface IProps {
  defaultValues: DeepPartial<CreateJobTitleInput>;
  onCompleted: (id?: number | null) => any;
}

export const useCreateJobTitle = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateJobTitleInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateJobTitleMutation,
    CreateJobTitleMutationVariables
  >(CREATE_JOB_TITLE, {
    refetchQueries: "active",
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createJobTitle?.ok) {
        onCompleted(data.createJobTitle.id);
      } else {
        throw Error(data?.createJobTitle?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
